import ModalLayout from "components/Modal";
import React, { useState } from "react";
import { PreBuiltAchievements } from "./AchievementStep";
import { Box } from "@mui/material";
import NavTabs from "../molecules/NavTabs";
import CreateFormFooter from "../atoms/CreateFormFooter";
import AddAchievementSection, {
  validateAchievements,
} from "./AddAchievementSection";
import useForms from "helpers/hooks/useForms";
import { toast } from "react-toastify";
import {
  customToast,
  deleteValues,
  payloadBool,
} from "helpers/utils/utilities";
import { useTranslation } from "react-i18next";
import useAchievements from "store/achievements/service-hook";

const UserAwards = ({ open, onClose, user = {} }) => {
  const [tab, setTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const { data, onChange, errors, setData } = useForms([]);
  const { t } = useTranslation("common");
  const { giveAward } = useAchievements();

  const resetNClose = () => {
    setTab(0);
    setData({});
    onClose();
  };

  const handleGiveAward = async () => {
    let payload = {
      is_pre_built_achievement: payloadBool(tab === 0),
      receiver_id: user?.email,
    };
    if (tab === 0) {
      if (!data.pre_built_achievement_id) {
        toast.error(t("Please select an award!"));
        return;
      }
      payload = {
        ...payload,
        achievement_id: data?.pre_built_achievement_id,
      };
    } else {
      deleteValues(data, ["pre_built_achievement_id"]);
      if (validateAchievements(data, false, (val) => t(val), true)) {
        return;
      }
      payload = {
        ...payload,
        ...data,
      };
    }
    setLoading(true);
    const res = await giveAward(payload);
    if (res?.success) {
      const isFirstAward = Boolean(res?.data?.achievement_id);
      !isFirstAward
        ? toast.success(res?.message)
        : customToast(
            res?.message,
            t("You have given the ${title} to ${name}", {
              title: res?.data?.title,
              name: user?.name,
            })
          ).success();
      if (isFirstAward) {
        setData({});
        onClose();
        setTab(0);
      }
    }
    setLoading(false);
  };

  return (
    <ModalLayout width="min(95vw,1000px)" open={open} onClose={resetNClose}>
      <Box className="mx-8 mx-2--mob my-4">
        <h2 className="c-title">
          {t("You are going to award")} {user?.name ?? "N/A"}
        </h2>
        <p className="c-title fs-14">
          {t(
            tab === 0
              ? "We have created a list of pre-built achievements to help you quickly select achievements."
              : "Create an achievement manually to award the user."
          )}
        </p>
        <NavTabs
          value={tab}
          onChange={setTab}
          list={["Pre-built Achievements", "Manually Upload"].map(t)}
          classes={tab === 0 && "mb-4"}
        />
        {tab === 0 && (
          <PreBuiltAchievements
            component="user_to_user_awarding"
            data={data}
            onChange={onChange}
            isUserAwardPopup
            receiverId={user?.email}
          />
        )}
        {tab === 1 && (
          <AddAchievementSection
            data={data}
            onChange={onChange}
            errors={errors}
            hideTitle
            showPreviewButton
          />
        )}
        <CreateFormFooter
          okButtonTitle={t("Award User")}
          okButtonColor="blue"
          backButtonColor="blue"
          fullWidth
          cancelButtonTitle="Cancel"
          onCancel={resetNClose}
          loading={loading}
          onOk={handleGiveAward}
        />
      </Box>
    </ModalLayout>
  );
};

export default UserAwards;
